/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IUserGroup = Models.IUserGroup;

    export interface IAdminGroupsListModalScope extends ng.IScope {
        username: string;
        groups: IUserGroup[];
        modalClose: () => void;
        modalSave: (groupId: string) => void;
    }

    export class AdminGroupsListModalController {
        public static templateURL: string = "decorators/modals/admin-groups-list-modal.html";
        public static ID: string = "#admin-groups-list-modal";
        public static $name: string = "adminGroupsListModalController";
        public static $inject: string[] = ['$scope', 'close', 'username', 'groups'];

        private $scope: IAdminGroupsListModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IAdminGroupsListModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    username: string,
                    groups: IUserGroup[]) {
            this.$scope = $scope;
            this.close = close;
            this.$scope.username = username;
            this.$scope.groups  = groups;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (groupId: string): void => {
                this.close(parseInt(groupId, 10));
            };
        }
    }
}
